import Widget from './Widget'

export default {
  install(app, _option) {
    app.component('UrChatWidget', Widget)
  },
}
